/* Moto Watchdog — theme.js
   Conversion-first interactions + Shopify cart integration
   ─────────────────────────────────────────────────────────────────── */

(function () {
  "use strict";

  // ── AJAX add-to-cart (shared across hero, picker, bundles) ───────
  async function refreshCartCount() {
    try {
      const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then(r => r.json());
      document.querySelectorAll(".cart-btn__count").forEach(el => {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll(".cart-btn").forEach(el => {
        el.classList.add("is-added");
        setTimeout(() => el.classList.remove("is-added"), 1000);
      });
    } catch (e) { /* offline / iframe — silently ignore */ }
  }

  async function ajaxAddToCart(form) {
    const fd = new FormData(form);
    const id = fd.get("id");
    const btn = form.querySelector("[type='submit']");
    const originalHTML = btn ? btn.innerHTML : "";

    // Fallback when no product is wired — open the redirect destination so the user
    // can still pick something to buy.
    if (!id) {
      window.location.href = form.dataset.redirectFallback || form.getAttribute("action") || "/collections/all";
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.dataset.busy = "1";
      btn.innerHTML = "Adding…";
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || "cart add failed");
      }
      await refreshCartCount();

      if (btn) {
        btn.innerHTML = "✓ Added to cart";
        btn.classList.add("is-success");
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.classList.remove("is-success");
          btn.disabled = false;
          btn.dataset.busy = "";
        }, 1800);
      }
    } catch (err) {
      console.error("[mw cart]", err);
      if (btn) {
        btn.innerHTML = err.message && err.message.length < 60 ? err.message : "Couldn't add — try again";
        btn.classList.add("is-error");
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.classList.remove("is-error");
          btn.disabled = false;
          btn.dataset.busy = "";
        }, 2200);
      }
    }
  }

  document.addEventListener("submit", function (e) {
    const form = e.target.closest("[data-shop-form]");
    if (!form) return;
    e.preventDefault();
    ajaxAddToCart(form);
  });

  // ── Frequently bought together: multi-item add ───────────────────
  document.querySelectorAll("[data-fbt-form]").forEach(function (fbt) {
    const toggles = Array.prototype.slice.call(fbt.querySelectorAll("[data-fbt-toggle]"));
    const totalEl = fbt.querySelector("[data-fbt-total]");
    const countEl = fbt.querySelector("[data-fbt-count]");
    const addBtn  = fbt.querySelector("[data-fbt-add]");
    if (!toggles.length || !addBtn) return;

    function money(cents) {
      const d = cents / 100;
      return "$" + (Number.isInteger(d) ? d.toString() : d.toFixed(2));
    }
    function refresh() {
      let total = 0, compare = 0, count = 0;
      toggles.forEach(function (t) {
        if (t.checked && t.value) {
          const p = parseInt(t.dataset.price || "0", 10);
          const c = parseInt(t.dataset.compare || t.dataset.price || "0", 10);
          total += p; compare += c; count++;
        }
      });
      if (totalEl) totalEl.innerHTML = money(total) + (compare > total ? ' <s>' + money(compare) + '</s>' : '');
      if (countEl) countEl.textContent = count + " item" + (count === 1 ? "" : "s");
      addBtn.disabled = count === 0;
    }
    toggles.forEach(function (t) {
      t.addEventListener("change", function () {
        if (t.dataset.locked) t.checked = true; // can't drop the viewed product
        refresh();
      });
    });
    addBtn.addEventListener("click", async function () {
      const items = toggles
        .filter(function (t) { return t.checked && t.value; })
        .map(function (t) { return { id: t.value, quantity: 1 }; });
      if (!items.length) return;
      const orig = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.innerHTML = "Adding…";
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          const err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || err.message || "cart add failed");
        }
        await refreshCartCount();
        addBtn.innerHTML = "✓ Added to cart";
        addBtn.classList.add("is-success");
        setTimeout(function () {
          addBtn.innerHTML = orig;
          addBtn.classList.remove("is-success");
          refresh();
        }, 1800);
      } catch (err) {
        console.error("[mw fbt]", err);
        addBtn.innerHTML = "Couldn't add — try again";
        addBtn.classList.add("is-error");
        setTimeout(function () {
          addBtn.innerHTML = orig;
          addBtn.classList.remove("is-error");
          refresh();
        }, 2200);
      }
    });
    refresh();
  });

  // ── Nav scroll state ─────────────────────────────────────────────
  const nav = document.querySelector("[data-nav]");
  if (nav) {
    const onScroll = () => nav.classList.toggle("is-scrolled", window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ── Sticky add-to-cart bar (shows after hero) ────────────────────
  const sb = document.querySelector("[data-stickybar]");
  const hero = document.querySelector("[data-hero]");
  if (sb && hero) {
    const io = new IntersectionObserver(
      (entries) => {
        const ent = entries[0];
        sb.classList.toggle("is-visible", !ent.isIntersecting);
      },
      { rootMargin: "-50px 0px 0px 0px" }
    );
    io.observe(hero);
  }

  // ── Savings calculator ───────────────────────────────────────────
  const calc = document.querySelector("[data-calc]");
  if (calc) {
    const deviceEl    = calc.querySelector("[data-calc-device]");
    const monthlyEl   = calc.querySelector("[data-calc-monthly]");
    const yearsEl     = calc.querySelector("[data-calc-years]");
    const deviceVal   = calc.querySelector("[data-calc-device-val]");
    const monthlyVal  = calc.querySelector("[data-calc-monthly-val]");
    const yearsVal    = calc.querySelector("[data-calc-years-val]");
    const compTotalEl = calc.querySelector("[data-calc-comp]");
    const oneTimeEl   = calc.querySelector("[data-calc-mw]");
    const savedEl     = calc.querySelector("[data-calc-saved]");
    const payoffEl    = calc.querySelector("[data-calc-payoff]");
    const payoffLine  = calc.querySelector("[data-calc-payoff-line]");
    const barSubEl    = calc.querySelector("[data-calc-bar-sub]");
    const barMwEl     = calc.querySelector("[data-calc-bar-mw]");
    const barSubLbl   = calc.querySelector("[data-calc-bar-sub-lbl]");
    const barSubVal   = calc.querySelector("[data-calc-bar-sub-val]");
    const yearsLbl    = calc.querySelector("[data-calc-years-lbl]");
    const oneTimePrice = parseInt(calc.dataset.oneTime || "149", 10);

    function fmt(n) { return "$" + Math.round(n).toLocaleString(); }
    function setRangeBg(el) {
      const min = +el.min, max = +el.max, v = +el.value;
      el.style.setProperty("--p", ((v - min) / (max - min)) * 100 + "%");
    }

    function recompute() {
      const d = deviceEl ? +deviceEl.value : 99;
      const m = +monthlyEl.value;
      const y = +yearsEl.value;
      // Their total = device + monthly × 12 × years
      const comp = d + (m * 12 * y);
      const saved = Math.max(0, comp - oneTimePrice);
      if (deviceVal)  deviceVal.textContent  = "$" + d;
      if (monthlyVal) monthlyVal.textContent = "$" + m + "/mo";
      if (yearsVal)   yearsVal.textContent   = y + " year" + (y > 1 ? "s" : "");
      if (compTotalEl) compTotalEl.textContent = fmt(comp);
      if (oneTimeEl)   oneTimeEl.textContent   = fmt(oneTimePrice);
      if (savedEl)     savedEl.textContent     = fmt(saved);
      // Break-even: when MW <= competitor's running total (device + months × monthly)
      // months = ceil((oneTimePrice - device) / monthly), floored at 0
      let breakEven;
      if (oneTimePrice <= d) {
        breakEven = 0;
      } else {
        breakEven = Math.ceil((oneTimePrice - d) / m);
      }
      if (payoffEl && payoffLine) {
        if (breakEven <= 0) {
          payoffLine.innerHTML = "<b>Cheaper than the alternative</b> <span style=\"color:var(--paper-text-2);font-weight:600;\">today \u2014 their device alone costs more.</span>";
        } else if (breakEven >= y * 12) {
          payoffLine.innerHTML = "<b>You save " + fmt(saved) + "</b> <span style=\"color:var(--paper-text-2);font-weight:600;\">over " + y + " year" + (y > 1 ? "s" : "") + ".</span>";
        } else {
          payoffEl.textContent = "month " + breakEven;
          payoffLine.innerHTML = "<b>Cheaper than the alternative</b> <span style=\"color:var(--paper-text-2);font-weight:600;\">from <b data-calc-payoff>month " + breakEven + "</b>.</span>";
        }
      }
      const max = Math.max(comp, oneTimePrice, 100);
      if (barSubEl) barSubEl.style.width = (comp / max * 100) + "%";
      if (barMwEl)  barMwEl.style.width  = (oneTimePrice / max * 100) + "%";
      if (barSubLbl) barSubLbl.textContent = "Subscription tracker \u00b7 $" + d + " + $" + m + "/mo";
      if (barSubVal) barSubVal.textContent = fmt(comp);
      if (yearsLbl)  yearsLbl.textContent  = "Cost over " + y + " year" + (y > 1 ? "s" : "");
      if (deviceEl)  setRangeBg(deviceEl);
      setRangeBg(monthlyEl);
      setRangeBg(yearsEl);
    }
    if (deviceEl)  deviceEl.addEventListener("input", recompute);
    monthlyEl.addEventListener("input", recompute);
    yearsEl.addEventListener("input", recompute);
    recompute();
  }

  // ── Use case tabs ────────────────────────────────────────────────
  const ucWrap = document.querySelector("[data-uc]");
  if (ucWrap) {
    const tabs = ucWrap.querySelectorAll("[data-uc-tab]");
    const bodies = ucWrap.querySelectorAll("[data-uc-body]");
    tabs.forEach((t) =>
      t.addEventListener("click", () => {
        const id = t.dataset.ucTab;
        tabs.forEach((x) => x.classList.toggle("is-active", x === t));
        bodies.forEach((b) => b.classList.toggle("is-active", b.dataset.ucBody === id));
      })
    );
  }

  // ── Shop hero: variant swap, ticker, viewer counter, ship countdown
  // Anchor on the variant chips (new compact buy-row) OR the legacy shopcard
  // aside, so the block runs regardless of which hero layout is in use.
  const shopcard =
    document.querySelector("[data-shop-variants]") ||
    document.querySelector("[data-shopcard]");
  if (shopcard) {
    // Visual fallback data — used when no Shopify product is wired up yet.
    const fallback = {
      car:     { meta: "MW-OBD · Best for cars & trucks",     name: "OBD Plug-and-Play tracker", price: "$129", strike: "$159", save: "Save $30", klarna: "$32", stock: 17,
                 feats: ["Lifetime 4G data","Real-time GPS","170+ countries","Plug & play install"] },
      moto:    { meta: "MW-HW · Best for motorcycles",        name: "Hardwire Stealth tracker",  price: "$149", strike: "$189", save: "Save $40", klarna: "$37", stock: 9,
                 feats: ["Concealed install","Ignition-aware","Tamper alerts","Lifetime 4G data"] },
      trailer: { meta: "HD-10000 · Trailers & equipment",     name: "HD-10000 Magnetic tracker", price: "$199", strike: "$249", save: "Save $50", klarna: "$50", stock: 12,
                 feats: ["10,000mAh battery","Weeks per charge","Magnetic mount","Rugged & weatherproof"] },
      family:  { meta: "HW-200 · Best for loved ones",        name: "HW-200 Personal tracker",   price: "$99",  strike: "$129", save: "Save $30", klarna: "$25", stock: 23,
                 feats: ["Pocket-sized","SOS button","Weeks of battery","Lifetime 4G data"] }
    };
    const live = window.MW_HERO_VARIANTS || {};

    const vbtns = document.querySelectorAll("[data-variant]");
    const svgs = document.querySelectorAll("[data-shop-svg]");
    const meta = document.querySelector("[data-shop-meta]");
    const name = document.querySelector("[data-shop-name]");
    const price = document.querySelector("[data-shop-price]");
    const strike = document.querySelector("[data-shop-strike]");
    const save = document.querySelector("[data-shop-save]");
    const klarna = document.querySelector("[data-shop-klarna]");
    const stockEl = document.querySelector("[data-shop-stock]");
    const ctaPrice = document.querySelector("[data-shop-cta-price]");
    const featsEl = document.querySelector("[data-shop-feats]");
    const vidInput = document.querySelector("[data-shop-vid]");
    const imgEl    = document.querySelector("[data-shop-img]");

    function applyVariant(key) {
      const f = fallback[key] || fallback.car;
      const l = live[key] || null;

      vbtns.forEach((b) => b.classList.toggle("is-active", b.dataset.variant === key));

      // Switch the product visual: real image when we have one, otherwise the
      // stylised SVG silhouette per category.
      const liveImg = l && l.image ? l.image : null;
      if (liveImg && imgEl) {
        imgEl.src = liveImg;
        imgEl.alt = l.title || "";
        imgEl.removeAttribute("hidden");
        imgEl.classList.add("is-active");
        svgs.forEach((s) => s.classList.remove("is-active"));
      } else {
        if (imgEl) imgEl.classList.remove("is-active");
        svgs.forEach((s) => s.classList.toggle("is-active", s.dataset.shopSvg === key));
      }

      // Prefer live Shopify data when present, fall back to mock.
      if (meta)     meta.textContent     = l ? (l.vendor + " · " + l.tag) : f.meta;
      if (name)     name.textContent     = l ? l.title : f.name;
      if (price)    price.textContent    = l ? l.price : f.price;
      if (strike)   strike.textContent   = l && l.on_sale ? l.compare : (l ? "" : f.strike);
      if (save)     save.textContent     = l && l.on_sale ? "Save " + l.save : (l ? "" : f.save);
      if (klarna)   klarna.textContent   = l ? l.klarna : f.klarna;
      if (stockEl)  stockEl.textContent  = l && l.stock != null ? l.stock : f.stock;
      if (ctaPrice) ctaPrice.textContent = l ? l.price : f.price;
      if (featsEl)  featsEl.innerHTML = f.feats.map(function (x) {
        return '<li><svg width="14" height="14" viewBox="0 0 24 24"><use href="#mw-check"/></svg> ' + x + '</li>';
      }).join("");

      // Critical: update the hidden form input so Add-to-Cart hits the right variant.
      if (vidInput && l && l.id) vidInput.value = l.id;
      else if (vidInput && !l)   vidInput.value = "";
    }
    vbtns.forEach(function (b) { b.addEventListener("click", function () { applyVariant(b.dataset.variant); }); });

    // Rotating ticker
    const tickerRows = document.querySelectorAll("[data-ticker] .hero__ticker-row");
    if (tickerRows.length > 1) {
      let ti = 0;
      setInterval(function () {
        ti = (ti + 1) % tickerRows.length;
        tickerRows.forEach(function (r, idx) { r.classList.toggle("is-active", idx === ti); });
      }, 3200);
    }

    // Live viewer counter — drifts naturally
    const viewerEl = document.querySelector("[data-live-viewers]");
    if (viewerEl) {
      let v = parseInt(viewerEl.textContent, 10) || 247;
      setInterval(function () {
        v += Math.floor(Math.random() * 5) - 2;
        v = Math.max(180, Math.min(312, v));
        viewerEl.textContent = v;
      }, 3500);
    }

    // Ship countdown — counts down to 3pm local
    const cdEl = document.querySelector("[data-ship-cd]");
    if (cdEl) {
      function tick() {
        const now = new Date();
        const target = new Date(now);
        target.setHours(15, 0, 0, 0);
        if (target <= now) target.setDate(target.getDate() + 1);
        const ms = target - now;
        const h = Math.floor(ms / 3600000);
        const m = Math.floor((ms % 3600000) / 60000);
        const s = Math.floor((ms % 60000) / 1000);
        cdEl.textContent =
          String(h).padStart(2, "0") + ":" +
          String(m).padStart(2, "0") + ":" +
          String(s).padStart(2, "0");
      }
      tick();
      setInterval(tick, 1000);
    }
  }

  // ── App-preview notification cycler ──────────────────────────────
  const notifWrap = document.querySelector("[data-notifs]");
  if (notifWrap) {
    const items = notifWrap.querySelectorAll(".notif");
    let i = 0;
    setInterval(() => {
      items.forEach((n, idx) => n.classList.toggle("is-on", idx === i % items.length));
      i++;
    }, 1500);
  }

  // ── Find your tracker picker ─────────────────────────────────────
  const pick = document.querySelector("[data-pick]");
  if (pick) {
    const fallback = {
      car: {
        device: "MW-OBD · Plug-and-Play",
        name: "OBD Plug-and-Play tracker",
        why: "Plugs into your car's OBD-II port in 10 seconds. Powered by the vehicle — no wires, no batteries, no install. Works on any car or truck from 1998 onwards.",
        price: "$129", strike: "$159"
      },
      moto: {
        device: "MW-HW · Hardwire Stealth",
        name: "Hardwire Stealth tracker",
        why: "Hides behind your fairing or under the seat, hardwired to constant power. Ignition-aware alerts and tamper notifications make this the pro-grade theft-recovery pick for bikes.",
        price: "$149", strike: "$189"
      },
      trailer: {
        device: "HD-10000 · Magnetic",
        name: "HD-10000 Magnetic tracker",
        why: "10,000mAh battery, magnetic mount, rugged weatherproof shell. Snap it onto any metal trailer, generator, or piece of equipment — weeks of tracking on a single charge.",
        price: "$199", strike: "$249"
      },
      family: {
        device: "HW-200 · Personal",
        name: "HW-200 Personal tracker",
        why: "Pocket-sized, lightweight, discreet. Weeks of battery in eco mode and built-in SOS. Slip it into a backpack, a jacket, or a bag — stays connected wherever they go.",
        price: "$99", strike: "$129"
      }
    };
    const live = window.MW_PICKER_VARIANTS || {};

    const cards = pick.querySelectorAll("[data-pick-id]");
    const dev = pick.querySelector("[data-pick-device]");
    const name = pick.querySelector("[data-pick-name]");
    const why = pick.querySelector("[data-pick-why]");
    const price = pick.querySelector("[data-pick-price]");
    const strike = pick.querySelector("[data-pick-strike]");
    const vidInput = pick.querySelector("[data-pick-vid]");

    cards.forEach(c => c.addEventListener("click", () => {
      cards.forEach(x => x.classList.toggle("is-active", x === c));
      const key = c.dataset.pickId;
      const f = fallback[key] || fallback.car;
      const l = live[key] || null;
      if (dev)    dev.textContent    = l ? l.device : f.device;
      if (name)   name.textContent   = l ? l.name : f.name;
      if (why)    why.textContent    = l ? l.why : f.why;
      if (price)  price.textContent  = l ? l.price : f.price;
      if (strike) strike.textContent = l && l.on_sale ? l.strike : (l ? "" : f.strike);
      if (vidInput) vidInput.value = l && l.id ? l.id : "";
    }));
  }

  // ── Coverage map dot field ───────────────────────────────────────
  const dotsHost = document.getElementById("dots");
  if (dotsHost) {
    const grid = [
      "  ........              ......      ",
      "  ##########         ##########.    ",
      " ############         #########.    ",
      "  ##########         ##########     ",
      "   #########        #############   ",
      "    ########        ##############  ",
      "     #######         ###########  ##",
      "      ######          #########   # ",
      "       #####           #######      ",
      "        ####            ###.        ",
      "         ###             ##         ",
      "          #               #         ",
      "                                    "
    ];
    const cellW = 16, cellH = 22, offX = 16, offY = 28;
    const NS = "http://www.w3.org/2000/svg";
    grid.forEach((row, y) => {
      for (let x = 0; x < row.length; x++) {
        const ch = row[x];
        if (ch !== "#" && ch !== ".") continue;
        const cx = offX + x * cellW;
        const cy = offY + y * cellH;
        const c = document.createElementNS(NS, "circle");
        c.setAttribute("cx", cx);
        c.setAttribute("cy", cy);
        c.setAttribute("r", ch === "#" ? 3.4 : 2.4);
        c.setAttribute("fill", ch === "#" ? "#FF541E" : "rgba(14,14,14,0.18)");
        dotsHost.appendChild(c);
      }
    });
    const hubs = [[160, 90], [320, 90], [430, 130], [110, 200], [340, 220]];
    hubs.forEach(([x, y]) => {
      const g = document.createElementNS(NS, "circle");
      g.setAttribute("cx", x); g.setAttribute("cy", y); g.setAttribute("r", 32);
      g.setAttribute("fill", "url(#cov-glow)");
      dotsHost.insertBefore(g, dotsHost.firstChild);
    });
  }

  // ── PDP gallery — thumbnail → view switcher ──────────────────────
  document.querySelectorAll("[data-pdp-gallery]").forEach((gallery) => {
    const thumbs = gallery.querySelectorAll("[data-thumb]");
    const views = gallery.querySelectorAll("[data-view]");
    if (!thumbs.length || !views.length) return;

    const main = gallery.querySelector(".pdp-gallery__main");

    // Force a square main container, regardless of cached/conflicting CSS.
    function sizeMain() {
      if (!main) return;
      const w = main.clientWidth || main.offsetWidth;
      if (w) main.style.height = w + "px";
    }
    if (main) {
      main.style.position = "relative";
      main.style.width = "100%";
      main.style.overflow = "hidden";
      sizeMain();
      window.addEventListener("resize", sizeMain);
      if (window.ResizeObserver) {
        try { new ResizeObserver(sizeMain).observe(main); } catch (e) {}
      }
    }

    // Inline-style fallback so non-active views are hidden even if the
    // .pdp-view { display:none } rule didn't load.
    function paint() {
      views.forEach((v) => {
        if (v.classList.contains("is-active")) {
          v.style.cssText = "position:absolute;inset:0;display:block;margin:0;width:100%;height:100%;";
          const img = v.querySelector("img");
          if (img) img.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
        } else {
          v.style.cssText = "display:none;";
        }
      });
    }

    function activate(key) {
      thumbs.forEach((t) => {
        const on = t.getAttribute("data-thumb") === key;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      views.forEach((v) => {
        v.classList.toggle("is-active", v.getAttribute("data-view") === key);
      });
      paint();
    }

    paint();

    thumbs.forEach((t, i) => {
      t.addEventListener("click", () => activate(t.getAttribute("data-thumb")));
      t.addEventListener("keydown", (e) => {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        e.preventDefault();
        const dir = e.key === "ArrowRight" ? 1 : -1;
        const next = thumbs[(i + dir + thumbs.length) % thumbs.length];
        next.focus();
        activate(next.getAttribute("data-thumb"));
      });
    });
  });

  // ── Express-pay buttons (Shop Pay / Apple Pay / Google Pay) ──────
  (function () {
    const buttons = document.querySelectorAll(".shopcard__pay");
    if (!buttons.length) return;

    let toastEl;
    function showToast(msg) {
      if (!toastEl) {
        toastEl = document.createElement("div");
        toastEl.className = "mw-pay-toast";
        toastEl.setAttribute("role", "status");
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      requestAnimationFrame(() => toastEl.classList.add("is-on"));
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(() => toastEl.classList.remove("is-on"), 1800);
    }

    buttons.forEach((btn) => {
      // wrap label so we can fade it under the spinner
      if (!btn.querySelector(".pay-label")) {
        const span = document.createElement("span");
        span.className = "pay-label";
        while (btn.firstChild) span.appendChild(btn.firstChild);
        btn.appendChild(span);
        const spin = document.createElement("span");
        spin.className = "pay-spin";
        spin.setAttribute("aria-hidden", "true");
        btn.appendChild(spin);
      }

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (btn.dataset.loading === "1") return;
        const method = btn.getAttribute("aria-label") || "Express checkout";
        btn.dataset.loading = "1";
        btn.disabled = true;
        // In live Shopify these buttons are replaced by the dynamic-checkout
        // snippet at runtime; this fallback just signals intent.
        setTimeout(() => {
          btn.dataset.loading = "0";
          btn.disabled = false;
          showToast("Redirecting to " + method + "…");
        }, 900);
      });
    });
  })();
})();
